import { getDPI } from '@/utils/unit-kit';
import type { RulerUnit } from './types';

// 刻度偏移量
export const SHORT_TICK_OFFSET = 17;
// 刻度大小
export const SHORT_TICK_SIZE = 6;
// 刻度数值偏移量
export const TEXT_OFFSET = 15;
// 刻度数值字体大小 @TODO 需要设置字体才会生效，目前字号是无效的
export const FONT_SIZE = '12px';
// 避免跟最后一个刻度重叠
export const MIN_LAST_GAP = 25;
// 标尺单位列表
export const RULER_UNIT_LIST: RulerUnit[] = ['px', 'cm', 'mm'];

/** 获取标尺刻度间距 */
export function getTickGap(scale: number, unit: RulerUnit) {
    let gap = 50;

    if (unit === 'px') {
        if (scale <= 0.04) {
            gap = 2500;
        } else if (scale <= 0.1) {
            gap = 1000;
        } else if (scale <= 0.2) {
            gap = 500;
        } else if (scale <= 0.4) {
            gap = 250;
        } else if (scale <= 1) {
            gap = 100;
        } else if (scale <= 2) {
            gap = 50;
        } else if (scale <= 4) {
            gap = 25;
        } else {
            gap = 10;
        }
    }

    if (unit === 'cm') {
        if (scale <= 0.1) {
            gap = 10;
        } else if (scale <= 0.4) {
            gap = 5;
        } else if (scale <= 1) {
            gap = 2;
        } else {
            gap = 1;
        }
    }

    if (unit === 'mm') {
        if (scale <= 0.1) {
            gap = 100;
        } else if (scale <= 0.4) {
            gap = 50;
        } else if (scale <= 1) {
            gap = 20;
        } else if (scale <= 2) {
            gap = 10;
        } else {
            gap = 5;
        }
    }

    return gap;
}

/** 获取像素尺寸与物理尺寸之间的换算比例 */
export function getPhysicalRatio(unit: RulerUnit) {
    const dpi = getDPI();
    if (unit === 'cm') return (1 / dpi) * 2.54;
    if (unit === 'mm') return (1 / dpi) * 25.4;
    return 1;
}
